import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchWorkflows, fetchWorkflow, fetchWorkflowRuns, executeWorkflow } from '../api/workflows';

export const workflowKeys = {
  all: ['workflows'] as const,
  list: () => [...workflowKeys.all, 'list'] as const,
  detail: (id: string) => [...workflowKeys.all, 'detail', id] as const,
  runs: (id: string) => [...workflowKeys.all, 'runs', id] as const,
};

export function useWorkflows() {
  return useQuery({
    queryKey: workflowKeys.list(),
    queryFn: fetchWorkflows,
  });
}

export function useWorkflow(id: string) {
  return useQuery({
    queryKey: workflowKeys.detail(id),
    queryFn: () => fetchWorkflow(id),
    enabled: !!id,
  });
}

export function useWorkflowRuns(id: string, hasActiveRun: boolean) {
  return useQuery({
    queryKey: workflowKeys.runs(id),
    queryFn: () => fetchWorkflowRuns(id),
    enabled: !!id,
    refetchInterval: hasActiveRun ? 2000 : 10000,
  });
}

export function useExecuteWorkflow(workflowId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (inputData?: Record<string, unknown>) => executeWorkflow(workflowId, inputData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: workflowKeys.runs(workflowId) });
    },
  });
}
